// --------------------------------------------------
// AMAZON BUTTON HANDLER (PDP + QUICK VIEW) + DEBUG
// --------------------------------------------------
(function () {
  const DEBUG = true; // <-- turn off after diagnosis
  const NS = "[Amazon]";
  const log = (...args) => DEBUG && console.log(NS, ...args);
  const warn = (...args) => DEBUG && console.warn(NS, ...args);

  // Keep a short history you can inspect via window.__amazonDebug.history
  const HISTORY_LIMIT = 80;
  window.__amazonDebug = window.__amazonDebug || { history: [] };
  function pushHistory(entry) {
    try {
      window.__amazonDebug.history.push({ t: Date.now(), ...entry });
      if (window.__amazonDebug.history.length > HISTORY_LIMIT) {
        window.__amazonDebug.history.shift();
      }
    } catch (e) {}
  }

  // --------------------------------------------------
  // 0) FREEZE ORIGINAL GLOBAL LOGO
  // --------------------------------------------------
  window.__amazonLogoGlobal = window.__amazonLogoGlobal || window.amazonLogo;

  // --------------------------------------------------
  // VALIDATE LOGO URL
  // --------------------------------------------------
  function getValidLogo(logoInput) {
    const raw = logoInput;
    if (!raw || typeof raw !== "string") return "";
    if (raw.includes("Liquid error")) return "";
    const trimmed = raw.trim();
    if (!trimmed) return "";
    return trimmed;
  }

  // --------------------------------------------------
  // DEBUG HELPERS
  // --------------------------------------------------
  function describeSelect(selectEl) {
    if (!selectEl) return {};
    const form = selectEl.closest("form");
    return {
      select_id: selectEl.id || "",
      select_name: selectEl.name || "",
      select_class: selectEl.className || "",
      in_quick_view: !!selectEl.closest(".quick-product"),
      form_id: form ? form.id || "" : "",
      form_class: form ? form.className || "" : "",
      form_product_handle: form ? form.getAttribute("data-product-handle") || "" : "",
      form_current_product_id: form ? form.getAttribute("data-current-product-id") || "" : ""
    };
  }

  function describeWrapper(wrapper) {
    if (!wrapper) return {};
    const form = wrapper.closest("form");
    return {
      wrapper_id: wrapper.id || "",
      wrapper_isConnected: !!wrapper.isConnected,
      wrapper_in_quick_view: !!wrapper.closest(".quick-product"),
      wrapper_form_id: form ? form.id || "" : ""
    };
  }

  function getContextFromSelect(selectEl) {
    // Keep your original context preference order
    return (
      selectEl.closest(".quick-product") ||
      selectEl.closest(".product") ||
      selectEl.closest("form.product-form")
    );
  }

  // --------------------------------------------------
  // BUILD OR UPDATE BUTTON
  // --------------------------------------------------
  function buildOrUpdateAmazonButton(contextEl, amazonUrl, debugMeta) {
    if (!contextEl) {
      warn("No contextEl provided", debugMeta);
      pushHistory({ type: "no_context", debugMeta });
      return;
    }

    const wrapper = contextEl.querySelector("[data-amazon-wrapper]");
    if (!wrapper) {
      warn("No wrapper found in context", { debugMeta });
      pushHistory({ type: "no_wrapper", debugMeta });
      return;
    }

    // Stable wrapper id for debugging
    if (!wrapper.dataset.amazonDebugId) {
      wrapper.dataset.amazonDebugId = Math.random().toString(36).slice(2, 9);
    }

    let btn = wrapper.querySelector("[data-amazon-button]");

    log("buildOrUpdateAmazonButton()", {
      amazonUrl,
      hasBtn: !!btn,
      wrapperDebugId: wrapper.dataset.amazonDebugId,
      wrapper: describeWrapper(wrapper),
      debugMeta
    });

    pushHistory({
      type: "build_or_update",
      amazonUrl,
      hasBtn: !!btn,
      wrapperDebugId: wrapper.dataset.amazonDebugId,
      wrapper: describeWrapper(wrapper),
      debugMeta
    });

    // No URL → remove button
    if (!amazonUrl) {
      if (btn) {
        warn("Removing button because amazonUrl is blank", {
          wrapperDebugId: wrapper.dataset.amazonDebugId,
          debugMeta
        });
        // This proves whether OUR code removed it (stack trace)
        if (DEBUG && console.trace) console.trace(NS + " remove trace");
        btn.remove();
        log("Removed button (no URL)");
      } else {
        log("No URL and no existing button to remove", {
          wrapperDebugId: wrapper.dataset.amazonDebugId,
          debugMeta
        });
      }
      return;
    }

    // Get globals (keeping your current names to avoid changing behaviour)
    const text = window.amazonBtnText || "Buy on Amazon";
    const bg = window.amazonBtnBg || "#FF9900";
    const color = window.amazonBtnTextColor || "#FFFFFF";

    // NOTE: your code uses window.amazonLogoPosition; some themes use window.amazonBtnLogoPosition.
    // For debugging, we’ll read both, without changing behaviour.
    const logoPos = window.amazonLogoPosition || window.amazonBtnLogoPosition || "left";

    const logoUrl = getValidLogo(window.__amazonLogoGlobal);

    // Create button if missing
    if (!btn) {
      btn = document.createElement("a");
      btn.setAttribute("data-amazon-button", "");
      btn.className = "amazon-buy-button omgrfq-product-link--processed";
      btn.target = "_blank";
      btn.rel = "noopener noreferrer";
      wrapper.appendChild(btn);
      log("Created new amazon button element", {
        wrapperDebugId: wrapper.dataset.amazonDebugId
      });
    }

    // Reset contents
    btn.href = amazonUrl;
    btn.style.backgroundColor = bg;
    btn.style.color = color;
    btn.innerHTML = "";

    // Logo ABOVE
    if (logoPos === "above" && logoUrl) {
      const imgAbove = document.createElement("img");
      imgAbove.src = logoUrl;
      imgAbove.loading = "lazy";
      imgAbove.className = "amazon-btn-logo amazon-btn-logo--above";
      btn.appendChild(imgAbove);
    }

    // Text
    const span = document.createElement("span");
    span.className = "amazon-btn-text";
    span.textContent = text;
    btn.appendChild(span);

    // Logo LEFT
    if (logoPos === "left" && logoUrl) {
      const imgLeft = document.createElement("img");
      imgLeft.src = logoUrl;
      imgLeft.loading = "lazy";
      imgLeft.className = "amazon-btn-logo amazon-btn-logo--left";
      btn.appendChild(imgLeft);
    }

    log("Button updated to:", amazonUrl, {
      wrapperDebugId: wrapper.dataset.amazonDebugId,
      debugMeta
    });

    pushHistory({
      type: "updated",
      amazonUrl,
      wrapperDebugId: wrapper.dataset.amazonDebugId,
      debugMeta
    });
  }

  // --------------------------------------------------
  // HANDLE VARIANT CHANGE WHEN <select> CHANGES
  // --------------------------------------------------
  function handleVariantChangeFromSelect(selectEl, source) {
    if (!selectEl) return;

    const selectedOption = selectEl.selectedOptions && selectEl.selectedOptions[0];
    if (!selectedOption) return;

    const variantId = selectedOption.value;
    const variantAmazon = selectedOption.dataset ? selectedOption.dataset.amazonUrl || "" : "";
    const fallbackAmazon = window.productAmazonUrl || "";
    const amazonUrl = variantAmazon || fallbackAmazon || "";

    const context = getContextFromSelect(selectEl);

    const wrapper = context ? context.querySelector("[data-amazon-wrapper]") : null;

    const debugMeta = {
      source: source || "unknown",
      variantId,
      variantAmazon,
      fallbackAmazon,
      used: amazonUrl,
      select: describeSelect(selectEl),
      wrapper: describeWrapper(wrapper)
    };

    log("Variant select change →", debugMeta);
    pushHistory({ type: "variant_change", ...debugMeta });

    buildOrUpdateAmazonButton(context, amazonUrl, debugMeta);
  }

  // --------------------------------------------------
  // LISTEN FOR ANY VARIANT <select> CHANGES
  // --------------------------------------------------
  document.addEventListener("change", (e) => {
    const select =
      e.target && e.target.closest ? e.target.closest("[data-variant-select]") : null;
    if (!select) return;

    handleVariantChangeFromSelect(select, "dom:change");
  });

  // --------------------------------------------------
  // INITIALIZE EXISTING FORMS ON PAGE LOAD
  // --------------------------------------------------
  document.addEventListener("DOMContentLoaded", () => {
    const selects = document.querySelectorAll("[data-variant-select]");
    log("DOMContentLoaded init. Found selects:", selects.length);

    selects.forEach((select) => handleVariantChangeFromSelect(select, "init:domcontentloaded"));

    // Watch wrappers to see if THE THEME removes our button node (DOM replacement)
    document.querySelectorAll("[data-amazon-wrapper]").forEach((wrapper) => {
      if (wrapper.dataset.amazonObserved === "1") return;
      wrapper.dataset.amazonObserved = "1";

      if (!wrapper.dataset.amazonDebugId) {
        wrapper.dataset.amazonDebugId = Math.random().toString(36).slice(2, 9);
      }

      const mo = new MutationObserver((muts) => {
        let removed = false;

        muts.forEach((m) => {
          (m.removedNodes || []).forEach((n) => {
            if (!n || n.nodeType !== 1) return;
            if (n.matches && n.matches("[data-amazon-button]")) removed = true;
            if (n.querySelector && n.querySelector("[data-amazon-button]")) removed = true;
          });
        });

        if (removed) {
          warn("Wrapper mutation: amazon button was removed from wrapper!", {
            wrapperDebugId: wrapper.dataset.amazonDebugId,
            wrapper: describeWrapper(wrapper)
          });
          pushHistory({
            type: "wrapper_removed_button",
            wrapperDebugId: wrapper.dataset.amazonDebugId,
            wrapper: describeWrapper(wrapper)
          });
        }
      });

      mo.observe(wrapper, { childList: true, subtree: true });
      log("Attached wrapper observer", {
        wrapperDebugId: wrapper.dataset.amazonDebugId,
        wrapper: describeWrapper(wrapper)
      });
    });
  });

  // --------------------------------------------------
  // OBSERVE QUICK VIEW BEING INJECTED (your original behaviour)
  // --------------------------------------------------
  const observer = new MutationObserver(() => {
    document
      .querySelectorAll(".quick-product [data-variant-select]")
      .forEach((select) => {
        if (!select.dataset.amazonInit) {
          select.dataset.amazonInit = "true";
          handleVariantChangeFromSelect(select, "observer:quickview_init");
        }
      });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // --------------------------------------------------
  // OPTIONAL: THEME FIRING product:variant-change EVENTS
  // --------------------------------------------------
  document.addEventListener("product:variant-change", () => {
    document.querySelectorAll("[data-variant-select]").forEach((select) => {
      handleVariantChangeFromSelect(select, "event:product-variant-change");
    });
  });
})();